import { ATP_API_URL } from "@config/apiconfig";
import apiClient from "@services/apiClient";

export const fetchClaimsList = async (params) => {
  try {
    let url = ATP_API_URL.GET_ALL_CLAIMS;

    if (params) {
      url = `${url}?${params}`;
    }

    const response = await apiClient.get(url);

    if (response?.data?.success) {
      return response.data;
    } else {
      return {
        success: false,
        data: [],
        message: response.data?.message || "Failed to fetch claims",
      };
    }
  } catch (error) {
    return error;
  }
};
